<ng-container *ngIf="dataLoaded">
	<div class="divider"><span>Actieve plattegrond</span></div>
	<img *ngIf="buildingMapImage" src="{{ buildingMapImage }}" alt="map" class="img-responsive">
</ng-container>
<div *ngIf="missingData.length" class="alert alert-danger" fxFlex fxLayout="row">
	<mat-icon>warning</mat-icon>
	<h2>Niet alle data is beschikbaar online, ga online om verder te gaan.</h2>
</div>
